import { useState } from "react";
import { toast } from "sonner";
import { assignSalon } from "@/lib/bf";

export default function BFAssign({ s, agents, onMoved }) {
  const [v, setV] = useState("");
  const move = () => assignSalon(s.id, v)
    .then(() => { toast.success(`${s.salon || "Salonul"} a fost mutat la ${(({ name, email } = {}) => name || email || "agent")(agents.find((a) => a.share_slug === v))}`); onMoved(s.id); window.dispatchEvent(new Event("bf-unassigned-refresh")); })
    .catch((e) => toast.error(e.response?.data?.detail || "Nu am putut muta salonul"));
  return (
    <div className="bf-assign" data-testid={`bf-assign-${s.id}`}>
      <select value={v} onChange={(e) => setV(e.target.value)} data-testid={`bf-assign-select-${s.id}`}>
        <option value="">Mută la agentul…</option>
        {agents.map((a) => <option key={a.share_slug} value={a.share_slug}>{a.name || a.email}</option>)}
      </select>
      <button type="button" className="st-btn st-btn--light" disabled={!v} onClick={move} data-testid={`bf-assign-save-${s.id}`}>Mută</button>
    </div>
  );
}
